/* PRODUCT 03 · Studio Manager
   Back-of-house: bookings, invoices, contracts, reviews. */
import React from "react";
import ProductPageLayout from "./ProductPageTemplate";

function DashboardMock({ title, lines }) {
  return (
    <div className="absolute inset-0 flex flex-col bg-[color:var(--charcoal-soft)]">
      <div className="px-3 py-2 border-b border-[color:var(--gold-foil)]/15">
        <div className="text-[9px] tracking-[0.22em] uppercase text-[color:var(--gold-base)]">{title}</div>
      </div>
      <div className="flex-1 p-3 space-y-2">
        {lines.map((l, i) => (
          <div key={i} className="flex items-center justify-between text-[10px] py-1.5 border-b border-[color:var(--gold-foil)]/8 last:border-0">
            <span className="text-[color:var(--cream)]/80">{l[0]}</span>
            <span className="font-mono text-[color:var(--gold-foil)]">{l[1]}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function InvoiceMock() {
  return (
    <div className="absolute inset-0 flex flex-col bg-[color:var(--cream-paper)] text-[color:var(--charcoal)]">
      <div className="px-4 py-3 border-b border-[color:var(--charcoal)]/10 flex items-center justify-between">
        <div>
          <div className="text-[8px] tracking-[0.22em] uppercase text-[color:var(--gold-deep)]">Invoice · Nº 24</div>
          <div className="font-serif italic text-xl mt-1">Maya Lee</div>
        </div>
        <div className="font-serif text-2xl">$1,240</div>
      </div>
      <div className="flex-1 p-4 space-y-1.5 text-[10px] text-[color:var(--charcoal)]/70">
        <div className="flex justify-between"><span>Spring editorial · portrait</span><span>$900</span></div>
        <div className="flex justify-between"><span>Extra edited frames · 6</span><span>$210</span></div>
        <div className="flex justify-between"><span>Linen album upgrade</span><span>$130</span></div>
      </div>
      <div className="px-4 py-2 border-t border-[color:var(--charcoal)]/10 text-[9px] tracking-[0.22em] uppercase text-[color:var(--gold-deep)]">PAID · ZELLE</div>
    </div>
  );
}

function CalendarMock() {
  const days = ["M","T","W","T","F","S","S"];
  const events = [3, 7, 12, 18, 24, 27];
  return (
    <div className="absolute inset-0 flex flex-col bg-[color:var(--charcoal-soft)] p-3">
      <div className="text-[9px] tracking-[0.22em] uppercase text-[color:var(--gold-base)]">May · 2026</div>
      <div className="grid grid-cols-7 gap-1 mt-3">
        {days.map((d, i) => <div key={i} className="text-[8px] uppercase tracking-wide text-[color:var(--cream)]/45 text-center">{d}</div>)}
        {Array.from({length: 30}).map((_, i) => {
          const n = i + 1;
          const isEvent = events.includes(n);
          return (
            <div
              key={n}
              className={`text-[9px] text-center py-1 ${isEvent ? "bg-[color:var(--gold-base)]/20 text-[color:var(--gold-foil)] border border-[color:var(--gold-foil)]/40" : "text-[color:var(--cream)]/55"}`}
            >{n}</div>
          );
        })}
      </div>
    </div>
  );
}

export default function ManagerPage() {
  return (
    <ProductPageLayout
      chapter="03"
      label="Studio Manager"
      headline={<>The back of house, quietly <em>choreographed</em>.</>}
      descriptor="Bookings, invoices, contracts, reviews, reminders — one quiet room. Every action you take talks to every other product without webhooks, exports, or duplicate typing."
      features={["BOOKINGS","INVOICES","CONTRACTS","REVIEWS","AVAILABILITY","CUSTOMERS","REMINDERS"]}
      primaryCta={{ label: "Tour the manager \u2192", href: "/admin" }}
      secondaryCta={{ label: "Pricing \u2192", href: "/marketing#pricing" }}
      previewItems={[
        { render: <CalendarMock /> },
        { render: <InvoiceMock /> },
        { render: <DashboardMock title="Bookings · May 2026" lines={[["Maya Lee · Editorial","Sat 10:00"],["Aurore Belle · Branding","Sun 14:30"],["Ines & Joao · Wedding","May 27"],["Sofia Marin · Family","Jun 02"]]} /> },
      ]}
    />
  );
}
